export const BRAND = 'katapult.most';

export const translations = {
  en: {
    brandAlt: 'katapult.most — live consciousness events',
    nav: {
      home: 'Home',
      services: 'Programs',
      about: 'About',
      connect: 'Connect',
      privacy: 'Privacy',
      learnMore: 'Learn more',
    },
    hero: {
      eyebrow: 'Live Consciousness Events',
      title: 'Return',
      titleAccent: 'inward',
      subtitle: 'Sacred gatherings, breath work, and ceremony for those quietly remembering themselves.',
      cta: 'See programs',
      scroll: 'Scroll',
      manifesto: 'Seeking the light, or living as the flame?\nThis is a sacred integration, transformation, and radical authenticity.\n\nThe future can start now.\nRubedo events and consultations were created for those who are ready to act.',
    },
    palette: {
      title: 'A palette',
      lead: 'The textures we hold space within.',
      colors: [
        { name: 'Ink', hex: '#0F0A0A' },
        { name: 'Burgundy', hex: '#5C1F2B' },
        { name: 'Dusty pink', hex: '#DDA7A5' },
        { name: 'Peach', hex: '#F3D8C7' },
        { name: 'Cream', hex: '#FAF6F2' },
      ],
    },
    services: {
      eyebrow: 'Programs',
      heading: 'Featured occasions',
      title: 'Doorways inward',
      subtitle: 'Each session is held with intention, breath, and a deep reverence for the body as temple.',
      learnMore: 'Learn more',
      close: 'Close',
      list: [
        {
          name: 'Kick-Start the Summer, Kick-Start Your Life!',
          subtitle: 'Transformative workshop for women',
          short: 'Kick-Start the Summer, Kick-Start Your Life!',
          paragraphs: [
            'If you think you have already found this year\u2019s soft female workshop, I will disappoint you.',
            'This is for women who are ready to set the summer in motion and no longer want to shrink themselves. Seize the chance to fully unfold within this magical small group — learn new skills and start accessing your deeper powers.',
            'Whatever your wish or aim, here you will find the space, the methods, and the energy that make reaching it easier — while connecting with like-minded women walking the same path.',
          ],
          details: [
            { label: 'Format', value: '4 sessions, 16:00–20:00' },
            { label: 'Dates', value: '15–16 & 29–30 June 2026, aligned with the lunar phases' },
            { label: 'Methods', value: 'Gendlin Focusing, neuroplasticity, group dynamics, visualisation, decision-making, sound bath' },
            { label: 'Group', value: '12 participants, closed circle' },
            { label: 'Price', value: '4 × €90' },
            { label: 'Location', value: 'Budapest' },
          ],
          host: { label: 'Held by: Katalin Szabó', linkTo: '/about' },
          duration: '4×4 hours · closed small group',
        },
        {
          name: 'Private 1:1 Sessions – You at the Centre',
          subtitle: 'Private 1:1',
          short: 'A bespoke alchemy crafted for your becoming.',
          paragraphs: [
            'If you are ready to connect more deeply with yourself and to uncover your inner resources, in our private sessions we work together in a safe and supportive space. These meetings open the way to seeing your goals more clearly, understanding your inner processes, and stepping into authentic self-expression and fulfilment.',
          ],
          details: [
            { label: 'Schedule', value: 'By individual arrangement' },
            { label: 'Location', value: 'Budapest, Sopron or online' },
          ],
          host: { label: 'Reach out and take a step towards yourself', linkTo: '#connect' },
          duration: '50 minutes · private',
        },
        {
          name: 'Sound Bath Rituals',
          short: 'The vibration of sound, the harmony of the soul.',
          duration: '90 minutes \u00b7 evenings',
        },
      ],
    },
    about: {
      eyebrow: 'Katalin Szab\u00f3',
      title: 'The one holding space',
      bodyA: 'My professional experience, my travels, my studies, and a decade-long therapeutic process allow me to create a safe space for the exploration of self-knowledge, personal agency, and inner growth.',
      bodyB: 'So you may be seen and loved.',
      longBio: [
        'I come from various fields of marketing communications and media, with 15 years of leadership experience. Over the course of my work, I have been on assignments in more than 21 countries, complemented by another 16 that I have visited out of personal interest. A subtle cultural perception, vertical and horizontal openness, and communication shape me at the foundation, just as do freedom and responsibility — the subject of my 2019 thesis at the close of my integral psychology studies.',
        'I take the occasion to note that these two concepts move in direct proportion, and this may well be one of the greatest challenges of our lives. After my studies, my life expanded with a kind of mentor function, and I accompany individuals and groups who set the deeper understanding of themselves as their aim. My functions are integrated, and whatever activity I am engaged in, I live by the same disciplines.',
        'In these sessions a space can arise where participants experience pure attention and acceptance — substances which open the way to an ever more authentic expression, to encountering and naming the shadows, so that the parts of the self can speak their needs to one another, so that the higher Self can perform its own healing on a higher frequency while I mirror it back.',
        'The primary aim of the encounters, therefore, is that each person develops an ever greater capacity to carry themselves, and to arrive into their own present, into their own reality — so that they can launch themselves toward their true goals.',
      ],
      learnMore: 'More',
      back: 'Back home',
      placeholder: 'I can help you tell your story',
    },
    connect: {
      eyebrow: 'Let\u2019s get to know each other',
      title: 'Connect',
      lead: 'Curious about an upcoming event, ready to sign up, or wondering whether it is for you at all? Write to me! There is no insignificant question — I read and answer every message myself. If you wish, I can also offer you a 15-minute online conversation, where you can get to know me and my approach a little better.',
      name: 'Your name',
      email: 'Email address',
      message: 'How can I help',
      send: 'Send',
      sending: 'Sending\u2026',
      sent: 'Received. I will write back soon.',
      error: 'Something went quiet. Please try again.',
      newsletterTitle: 'The inner circle',
      newsletterLead: 'A collective instead of a newsletter, meaning instead of noise — from time to time I send exclusive invitations and intuitive thoughts, personally tailored, personally written.',
      subscribe: 'Subscribe',
      subscribing: 'Subscribing\u2026',
      subscribed: 'You are in. Welcome.',
      mailDirect: 'Or get in touch directly',
    },
    footer: {
      rights: 'All rights reserved',
      designed: 'All rights reserved',
      marquee: ['letting go', 'receiving', 'unfolding', 'authenticity', 'ritual'],
    },
    privacy: {
      title: 'Privacy Policy',
      back: 'Back home',
      updated: 'Last updated',
      sections: [
        {
          h: 'Privacy',
          paragraphs: [
            'Your data matters to you. It matters to us, too. That is why we handle it to the best of our knowledge and conscience. The legal basis for this is the European General Data Protection Regulation (GDPR). You can read this and other data-protection rules applicable in Austria here: {gesetze}',
            'The following privacy policy applies to {site} — if we link to other sites, and we often do, those other sites may have different privacy policies. We also update this policy regularly, whenever we find a better way to keep your data safe, or whenever the legislator asks us to.',
          ],
        },
        {
          h: 'Rights',
          paragraphs: [
            'Under the GDPR you have the right to information about the data we hold concerning you, as well as the right to correction, deletion, restriction of, and objection to its processing. Please contact us at {email} for these matters. We will respond to your request as quickly as possible.',
          ],
        },
        {
          h: 'Newsletter',
          paragraphs: [
            'We only send our newsletter to people who have subscribed to it on {site} or in person at events. To ensure this, we use a double-opt-in procedure: right after you sign up, we send you a confirmation email. As soon as you click the confirmation link, we use your email address for further communication. In this way we make sure we never send unsolicited emails. Of course, every email contains a link to unsubscribe.',
          ],
        },
        {
          h: 'Cookies',
          paragraphs: [
            'As soon as you visit our website, a log file is automatically created on our server in order to ensure technical reliability and to improve our services. We use cookies, among other tools. Some cookies remain stored on your device until you delete them. They allow us to recognise your browser on your next visit. If you do not wish this, you can configure your browser to inform you when cookies are set and ask for your permission.',
          ],
        },
        {
          h: 'Google Analytics',
          paragraphs: [
            'To improve the design of our website, we use Google Analytics. This web-analysis service uses cookies to evaluate website usage. Information about your use of the website is usually transmitted to a server in the USA and stored there. {site} uses Google Analytics with IP-anonymisation activated, so that your IP address is shortened within the European Union and thus anonymised. The IP address transmitted by your browser within Google Analytics is not merged with other Google data.',
          ],
        },
        {
          h: 'Contact',
          paragraphs: [
            'If you have any questions about how we handle your data, please simply write to us at {email}. For further information we recommend the Austrian Data Protection Authority ({dsb}). This is also the authority you can contact if, in your opinion, we have violated data-protection regulations in our handling of your data.',
          ],
        },
      ],
    },
    common: { lang: 'EN' },
  },
  de: {
    brandAlt: 'katapult.most \u2014 Live-Bewusstseins-Veranstaltungen',
    nav: { home: 'Start', services: 'Programme', about: '\u00dcber mich', connect: 'Kontakt', privacy: 'Datenschutz', learnMore: 'Mehr erfahren' },
    hero: {
      eyebrow: 'Live-Bewusstseins-Veranstaltungen',
      title: 'Kehre',
      titleAccent: 'nach innen',
      subtitle: 'Heilige Zusammenk\u00fcnfte, Atemarbeit und Zeremonie f\u00fcr jene, die sich still erinnern.',
      cta: 'Programme ansehen',
      scroll: 'Scrollen',
      manifesto: 'Lichtsuche oder Leben als Flamme?\nDies ist eine sakrale Integration, Transformation und radikale Authentizität.\n\nDie Zukunft kann jetzt beginnen.\nDie Rubedo Events und Sitzungen wurden für jene geschaffen, die bereit sind zu handeln.',
    },
    palette: {
      title: 'Eine Palette',
      lead: 'Die Texturen, in denen wir Raum halten.',
      colors: [
        { name: 'Tinte', hex: '#0F0A0A' },
        { name: 'Burgund', hex: '#5C1F2B' },
        { name: 'Altrosa', hex: '#DDA7A5' },
        { name: 'Pfirsich', hex: '#F3D8C7' },
        { name: 'Creme', hex: '#FAF6F2' },
      ],
    },
    services: {
      eyebrow: 'Programme',
      heading: 'Besondere Anl\u00e4sse',
      title: 'T\u00fcren nach innen',
      subtitle: 'Jede Session wird gehalten mit Klang, Atem und einer tiefen Ehrfurcht f\u00fcr den K\u00f6rper als Tempel.',
      learnMore: 'Mehr erfahren',
      close: 'Schlie\u00dfen',
      list: [
        {
          name: 'Stoß den Sommer an, stoß dein Leben an!',
          subtitle: 'Transformativer Workshop für Frauen',
          short: 'Stoß den Sommer an, stoß dein Leben an!',
          paragraphs: [
            'Falls du glaubst, deinen Soft-Female-Workshop für dieses Jahr bereits gefunden zu haben, werde ich dich enttäuschen müssen.',
            'Dieser Workshop richtet sich an Frauen, die bereit sind, den Sommer in Bewegung zu setzen und sich nicht mehr klein machen wollen. Ergreife die Gelegenheit, dich in dieser magischen Kleingruppe voll zu entfalten — lerne neue Fähigkeiten und beginne, deine tieferen Kräfte anzuzapfen.',
            'Was immer dein Wunsch oder dein Ziel ist — hier findest du den Raum, die Methoden und die Energie, die das Erreichen leichter machen, während du dich mit gleichgesinnten Frauen verbindest, die denselben Weg gehen.',
          ],
          details: [
            { label: 'Format', value: '4 Termine, 16:00–20:00' },
            { label: 'Termine', value: '15.–16. & 29.–30. Juni 2026, im Einklang mit den Mondphasen' },
            { label: 'Methoden', value: 'Focusing nach Gendlin, Neuroplastizität, Gruppendynamik, Visualisierung, Entscheidungstraining, Klangbad' },
            { label: 'Gruppe', value: '12 Teilnehmerinnen, geschlossener Kreis' },
            { label: 'Preis', value: '4 × 90 €' },
            { label: 'Ort', value: 'Budapest' },
          ],
          host: { label: 'Geleitet von: Katalin Szabó', linkTo: '/about' },
          duration: '4×4 Stunden · geschlossene Kleingruppe',
        },
        {
          name: 'Einzelsitzungen 1:1 – Du im Mittelpunkt',
          subtitle: 'Einzeln 1:1',
          short: 'Eine Alchemie, geformt für dein Werden.',
          paragraphs: [
            'Wenn du bereit bist, dich tiefer mit dir selbst zu verbinden und deine inneren Ressourcen zu entdecken, arbeiten wir in den Einzelsitzungen gemeinsam in einem sicheren und unterstützenden Raum. Diese Begegnungen geben dir die Möglichkeit, deine Ziele klarer zu sehen, deine inneren Prozesse zu verstehen und dich auf den Weg zu authentischem Ausdruck und Entfaltung zu begeben.',
          ],
          details: [
            { label: 'Termin', value: 'Nach individueller Absprache' },
            { label: 'Ort', value: 'Budapest, Sopron oder online' },
          ],
          host: { label: 'Melde dich und mache einen Schritt zu dir selbst', linkTo: '#connect' },
          duration: '50 Minuten · privat',
        },
        { name: 'Klang-Rituale', short: 'Die Schwingung des Klangs, die Harmonie der Seele.', duration: '90 Minuten \u00b7 abends' },
      ],
    },
    about: {
      eyebrow: 'Katalin Szab\u00f3',
      title: 'Die, die den Raum h\u00e4lt',
      bodyA: 'Meine berufliche Erfahrung, meine Reisen, mein Studium und ein zehn Jahre andauernder therapeutischer Prozess erm\u00f6glichen es mir, einen sicheren Raum f\u00fcr die Entdeckung von Selbsterkenntnis, pers\u00f6nlicher Wirksamkeit und innerem Wachstum zu schaffen.',
      bodyB: 'Damit du gesehen und geliebt wirst.',
      longBio: [
        'Ich komme aus verschiedenen Bereichen der Marketingkommunikation und Medien und verf\u00fcge \u00fcber 15 Jahre F\u00fchrungserfahrung. Im Laufe meiner T\u00e4tigkeit war ich in mehr als 21 L\u00e4ndern auf Eins\u00e4tzen, erg\u00e4nzt durch weitere 16 L\u00e4nder, die ich aus pers\u00f6nlichem Interesse bereist habe. Eine subtile kulturelle Wahrnehmung, vertikale und horizontale Offenheit sowie Kommunikation pr\u00e4gen mich im Fundament, ebenso wie Freiheit und Verantwortung \u2014 das Thema meiner Diplomarbeit 2019 zum Abschluss meines integralpsychologischen Studiums.',
        'Ich nutze die Gelegenheit, hier festzuhalten, dass diese beiden Begriffe sich im direkten Verh\u00e4ltnis zueinander bewegen und vielleicht eine der gr\u00f6\u00dften Herausforderungen unseres Lebens darstellen. Im Anschluss daran erweiterte sich mein Leben um eine Art Mentor-Funktion, und ich begleite Einzelpersonen und Gruppen, die ein tieferes Verst\u00e4ndnis ihrer selbst anstreben. Meine Funktionen sind integriert, und welche T\u00e4tigkeit ich auch aus\u00fcbe \u2014 ich lebe nach denselben Disziplinen.',
        'In diesen Sitzungen kann ein Raum entstehen, in dem die Teilnehmenden reine Aufmerksamkeit und Annahme erfahren \u2014 Substanzen, die den Weg zu einem immer authentischeren Ausdruck \u00f6ffnen, zur Begegnung mit Schatten und zu deren Benennung, damit die Anteile des Selbst einander ihre Bed\u00fcrfnisse mitteilen k\u00f6nnen, damit das h\u00f6here Selbst auf einer h\u00f6heren Frequenz Selbstheilung vollziehen kann, w\u00e4hrend ich es spiegele.',
        'Das prim\u00e4re Ziel der Sitzungen ist es daher, dass die Person eine immer gr\u00f6\u00dfere Kapazit\u00e4t entwickelt, sich selbst zu tragen und in ihrer eigenen Gegenwart, in ihrer eigenen Realit\u00e4t anzukommen.',
      ],
      learnMore: 'Mehr',
      back: 'Zur\u00fcck',
      placeholder: 'Ich kann dir helfen, deine Geschichte zu erz\u00e4hlen',
    },
    connect: {
      eyebrow: 'Lass uns einander kennenlernen', title: 'Kontakt',
      lead: 'Neugierig auf eine bevorstehende Veranstaltung, m\u00f6chtest du dich anmelden, oder fragst du dich, ob es \u00fcberhaupt etwas f\u00fcr dich ist? Schreib mir! Es gibt keine unbedeutende Frage \u2014 jede Nachricht lese und beantworte ich pers\u00f6nlich. Auf Wunsch kann ich dir auch ein 15-min\u00fctiges Online-Gespr\u00e4ch anbieten, in dem du mich und meine Arbeit etwas n\u00e4her kennenlernst.',
      name: 'Dein Name', email: 'E-Mail-Adresse', message: 'Wie kann ich helfen', send: 'Senden',
      sending: 'Senden\u2026', sent: 'Erhalten. Ich schreibe bald zur\u00fcck.', error: 'Etwas wurde still. Bitte erneut versuchen.',
      newsletterTitle: 'Der innere Kreis',
      newsletterLead: 'Ein Kollektiv statt eines Newsletters, Bedeutung statt L\u00e4rm \u2014 von Zeit zu Zeit sende ich exklusive Einladungen und intuitive Gedanken, pers\u00f6nlich zugeschnitten, pers\u00f6nlich geschrieben.',
      subscribe: 'Abonnieren', subscribing: 'Abonnieren\u2026', subscribed: 'Du bist dabei. Willkommen.', mailDirect: 'Oder nimm direkt Kontakt auf',
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      designed: 'Alle Rechte vorbehalten',
      marquee: ['loslassen', 'empfangen', 'entfaltung', 'echtheit', 'ritual'],
    },
    privacy: {
      title: 'Datenschutz', back: 'Zur\u00fcck', updated: 'Zuletzt aktualisiert',
      sections: [
        {
          h: 'Datenschutz',
          paragraphs: [
            'Deine Daten sind dir wichtig. Uns auch. Deshalb versuchen wir nach bestem Wissen und Gewissen mit ihnen umzugehen. Die rechtliche Basis daf\u00fcr bietet die europ\u00e4ische Datenschutzgrundverordnung (DSGVO). Diese wie andere in \u00d6sterreich g\u00fcltige Bestimmungen zum Datenschutz kannst du dir \u00fcbrigens hier ansehen: {gesetze}',
            'Die folgende Datenschutzerkl\u00e4rung gilt f\u00fcr {site} \u2014 sollten wir auf andere Seiten verlinken, und das tun wir oft, dann haben diese anderen Seiten mitunter andere Datenschutzrichtlinien. Auch werden wir unsere Datenschutzerkl\u00e4rung regelm\u00e4\u00dfig updaten, wenn wir einen noch besseren Weg gefunden haben, deine Daten sicher zu verwahren, oder die Gesetzgeberin uns dazu veranlasst.',
          ],
        },
        {
          h: 'Rechte',
          paragraphs: [
            'Du hast laut DSGVO ein Recht auf Auskunft \u00fcber dich betreffende Daten sowie auf Berichtigung, L\u00f6schung oder auf Einschr\u00e4nkung der und Widerspruch gegen die Verarbeitung. Wende dich hierf\u00fcr bitte an {email}. Wir werden uns dann schnellstm\u00f6glich deines Anliegens annehmen.',
          ],
        },
        {
          h: 'Newsletter',
          paragraphs: [
            'Wir schicken unseren Newsletter nur an Menschen, die ihn auf {site} oder analog bei Events bestellt haben. Um das sicherzustellen, nutzen wir das Double-Opt-in-Verfahren: Wir senden dir gleich nach deiner Anmeldung ein Best\u00e4tigungsmail. Sobald du den Best\u00e4tigungslink aktiviert hast, nutzen wir deine Mail-Adresse zur weiteren Kommunikation. So wollen wir sicherstellen, dass wir nicht ungefragt Mails an dich und andere verschicken. Dass jede Mail die M\u00f6glichkeit enth\u00e4lt, den Newsletter per Link abzubestellen, versteht sich von selbst.',
          ],
        },
        {
          h: 'Cookies',
          paragraphs: [
            'Sobald du unsere Website besuchst, wird auf unserem Server automatisch eine Protokolldatei erstellt, um die technische Sicherstellung und die Verbesserung unserer Dienste zu gew\u00e4hrleisten. Dazu nutzen wir unter anderem Cookies. Einige Cookies bleiben solange auf deinem Endger\u00e4t gespeichert, bis du sie l\u00f6schst. Sie erm\u00f6glichen es uns, deinen Browser beim n\u00e4chsten Besuch wiederzuerkennen. Willst du das nicht, kannst du deinen Browser nat\u00fcrlich so einrichten, dass er dich \u00fcber das Setzen von Cookies informiert und dich um Erlaubnis bittest.',
          ],
        },
        {
          h: 'Google Analytics',
          paragraphs: [
            'Um die Gestaltung unserer Website zu verbessern, benutzen wir Google Analytics. Dieser Webanalysedienst verwendet Cookies, um die Nutzung der Website auszuwerten. Dazu werden Informationen \u00fcber die Nutzung einer Website in der Regel an einen Server in den USA \u00fcbertragen und dort gespeichert. {site} verwendet Google Analytics mit aktivierter IP-Anonymisierung, sodass deine IP-Adresse innerhalb der Europ\u00e4ischen Union gek\u00fcrzt und somit anonymisiert wird. Die im Rahmen von Google Analytics von deinem Browser \u00fcbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\u00fchrt.',
          ],
        },
        {
          h: 'Kontakt mit uns',
          paragraphs: [
            'Solltest du Fragen zu unserem Umgang mit deinen Daten haben, schreib uns doch einfach an {email}. F\u00fcr weitere Ausk\u00fcnfte k\u00f6nnen wir dir die Datenschutzbeh\u00f6rde empfehlen ({dsb}). Das ist \u00fcbrigens auch jene Beh\u00f6rde, an die du dich wenden kannst, wenn wir deiner Meinung nach im Umgang mit deinen Daten gegen Schutzbestimmungen versto\u00dfen h\u00e4tten.',
          ],
        },
      ],
    },
    common: { lang: 'DE' },
  },
  hu: {
    brandAlt: 'katapult.most \u2014 \u00e9l\u0151 tudatoss\u00e1gi esem\u00e9nyek',
    nav: { home: 'F\u0151oldal', services: 'Programok', about: 'R\u00f3lam', connect: 'Kapcsolat', privacy: 'Adatv\u00e9delem', learnMore: 'Tov\u00e1bb' },
    hero: {
      eyebrow: '\u00c9l\u0151 tudatoss\u00e1gi esem\u00e9nyek',
      title: 'T\u00e9rj',
      titleAccent: 'magadhoz',
      subtitle: 'Szents\u00e9ges \u00f6sszej\u00f6vetelek, l\u00e9gz\u00e9smunka \u00e9s szertart\u00e1s azoknak, akik csendben hazatal\u00e1lnak \u00f6nmagukhoz.',
      cta: 'Programok',
      scroll: 'Görgess',
      manifesto: 'Fénykeresés helyett lángoló élet?\nEz a szakrális integráció, átalakulás és radikális hitelesség útja.\n\nA jövő elkezdődhet most.\nA Rubedo eseményeket és konzultációkat azok számára hoztam létre, akik készen állnak a "majd ha..." elengedésére.',
    },
    palette: {
      title: 'Egy paletta',
      lead: 'A text\u00farak, melyekben teret tartunk.',
      colors: [
        { name: 'Tinta', hex: '#0F0A0A' },
        { name: 'Burgundi', hex: '#5C1F2B' },
        { name: 'Por r\u00f3zsa', hex: '#DDA7A5' },
        { name: '\u0150szibarack', hex: '#F3D8C7' },
        { name: 'Krém', hex: '#FAF6F2' },
      ],
    },
    services: {
      eyebrow: 'Programok',
      heading: 'Kiemelt alkalmak',
      title: 'Kapuk befel\u00e9',
      subtitle: 'Minden alkalom sz\u00e1nd\u00e9kkal, l\u00e9legzettel \u00e9s a test mint templom ir\u00e1nti m\u00e9ly tisztelettel tartva.',
      learnMore: 'Tov\u00e1bb',
      close: 'Bez\u00e1r',
      list: [
        {
          name: 'Lökd be a nyarat, lökd be az életed!',
          subtitle: 'Transzformatív workshop nőknek',
          short: 'Lökd be a nyarat, lökd be az életed!',
          paragraphs: [
            'Ha azt hiszed, hogy megtaláltad az idei soft female workshopodat, akkor csalódást fogok okozni.',
            'Ez azoknak a nőknek szól, akik készen állnak beindítani a nyarat, és nem akarnak többé összehúzódni. Ragadd meg az alkalmat, hogy kiteljesedj ebben a mágikus kiscsoportban! Tanulj új készségeket, és kezdj el hozzáférni a mélyebb erőidhez.',
            'Bármi is legyen a vágyad vagy célod, itt olyan teret, módszereket és energiát kapsz, amelyek megkönnyítik az elérésüket, közben kapcsolódj hasonló gondolkodású nőkkel, akik ugyanazon az úton járnak, mint te.',
          ],
          details: [
            { label: 'Formátum', value: '4 alkalom, 16:00–20:00' },
            { label: 'Dátumok', value: '2026, június 15–16 & 29–30, a holdfázisokhoz igazodva' },
            { label: 'Módszerek', value: 'Gendlin-féle Focusing, neuroplaszticitás, csoportdinamika, vizualizáció, döntéskészség-fejlesztés, hangfürdő' },
            { label: 'Csoport', value: '12 fő, zárt csoportban' },
            { label: 'Ár', value: '4 × 27.000 Ft' },
            { label: 'Helyszín', value: 'Budapest' },
          ],
          host: { label: 'Tartja: Szabó Katalin', linkTo: '/about' },
          duration: '4×4 óra · zárt kiscsoport',
        },
        {
          name: 'Egyéni 1:1 Ülések – Fókuszban Csak Te',
          subtitle: 'Egyéni 1:1',
          short: 'Egyedi alkímia a te bontakozásodra.',
          paragraphs: [
            'Ha készen állsz mélyebben kapcsolódni önmagadhoz, és szeretnéd feltárni belső erőforrásaidat, az egyéni ülések során biztonságos és támogató térben dolgozhatunk együtt. Ezek az alkalmak lehetőséget adnak arra, hogy tisztábban lásd céljaidat, megértsd belső folyamataidat, és elindulj az autentikus önkifejezés és kiteljesedés felé.',
          ],
          details: [
            { label: 'Időpont', value: 'Egyéni egyeztetés alapján' },
            { label: 'Helyszín', value: 'Budapest, Sopron vagy online' },
          ],
          host: { label: 'Keress bizalommal és tegyél egy lépést önmagad felé', linkTo: '#connect' },
          duration: '50 perc · privát',
        },
        { name: 'Hangf\u00fcrd\u0151 rituál\u00e9k', short: 'A hang rezgése, a lélek harmóniája.', duration: '90 perc \u00b7 esti' },
      ],
    },
    about: {
      eyebrow: 'Szab\u00f3 Katalin',
      title: 'Aki a teret tartja',
      bodyA: 'Szakmai tapasztalatom, utaz\u00e1saim, tanulm\u00e1nyaim \u00e9s egy \u00e9vtizedes ter\u00e1pi\u00e1s folyamat teszi lehet\u0151v\u00e9, hogy biztons\u00e1gos teret teremtsek az \u00f6nismeret, az egy\u00e9ni hat\u00f3er\u0151 \u00e9s a szem\u00e9lyes fejl\u0151d\u00e9s felfedez\u00e9s\u00e9hez.',
      bodyB: 'Hogy l\u00e1ttass \u00e9s szerettess.',
      longBio: [
        'A marketingkommunik\u00e1ci\u00f3 \u00e9s m\u00e9dia k\u00fcl\u00f6nb\u00f6z\u0151 ter\u00fclet\u00e9ir\u0151l \u00e9rkeztem, 15 \u00e9v vezet\u0151i tapasztalattal rendelkezem \u00e9s munk\u00e1m sor\u00e1n t\u00f6bb, mint 21 orsz\u00e1gban voltam kik\u00fcldet\u00e9sen, melyet tov\u00e1bbi 16 orsz\u00e1g eg\u00e9sz\u00edt ki, ahov\u00e1 egy\u00e9ni \u00e9rdekl\u0151d\u00e9sb\u0151l l\u00e1togattam el. A kultur\u00e1lis szubtilis \u00e9rz\u00e9kel\u00e9s, a vertik\u00e1lis \u00e9s horizont\u00e1lis nyitotts\u00e1g \u00e9s kommunik\u00e1ci\u00f3 alapjaiban hat\u00e1roz meg, \u00e9pp \u00fagy mint a szabads\u00e1g \u00e9s a felel\u0151ss\u00e9g, melyr\u0151l 2019-ben \u00edrtam szakdolgozatomat, integr\u00e1l pszichol\u00f3giai tanulm\u00e1nyaim befejez\u00e9sek\u00e9pp.',
        'Megragadom az alkalmat \u00e9s ismertetem ez\u00faton is, hogy a k\u00e9t fogalom egyenes ar\u00e1nyban v\u00e1ltozik \u00e9s tal\u00e1n ez jelenti az egyik legnagyobb kih\u00edv\u00e1st \u00e9let\u00fcnk sor\u00e1n. Ezt k\u00f6vet\u0151en eg\u00e9sz\u00fclt ki az \u00e9letem egyfajta mentor funkci\u00f3val \u00e9s k\u00eds\u00e9rek \u00f6nmaguk m\u00e9lyebb meg\u00e9rt\u00e9s\u00e9t c\u00e9lul kit\u0171z\u0151 egy\u00e9neket \u00e9s csoportokat. Funkci\u00f3im integr\u00e1ltak \u00e9s b\u00e1rmilyen tev\u00e9kenys\u00e9get is v\u00e9gzek, azonos diszcipl\u00edn\u00e1kkal \u00e9lek.',
        'Az eml\u00edtett \u00fcl\u00e9sek sor\u00e1n l\u00e9trej\u00f6het egy t\u00e9r, ahol a r\u00e9sztvev\u0151k tiszta figyelmet \u00e9s elfogad\u00e1st tapasztalhatnak, mely szubsztanci\u00e1k lehet\u0151s\u00e9get adhatnak az egyre autentikusabb megnyilv\u00e1nul\u00e1sra, \u00e1rny\u00e9kok megtapasztal\u00e1s\u00e1ra, megnevez\u00e9s\u00e9re, hogy az \u00e9nr\u00e9szek besz\u00e1molhassanak egym\u00e1snak ig\u00e9nyeikr\u0151l, hogy a fels\u0151bb-\u00e9n \u00f6ngy\u00f3gy\u00edt\u00e1st hajthasson v\u00e9gre egy magasabb frekvenci\u00e1n, mik\u00f6zben t\u00fckr\u00f6z\u00f6m \u0151t.',
        'A tal\u00e1lkoz\u00e1sok els\u0151dleges c\u00e9lja teh\u00e1t, hogy az egy\u00e9n egyre nagyobb kapacit\u00e1ssal rendelkezzen \u00f6nmaga visel\u00e9s\u00e9re \u00e9s meg\u00e9rkezzen saj\u00e1t jelen\u00e9be, realit\u00e1s\u00e1ba, hogy elrugaszkodhasson val\u00f3di c\u00e9ljai fel\u00e9.',
      ],
      learnMore: 'B\u0151vebben',
      back: 'Vissza',
      placeholder: 'Seg\u00edthetek elmes\u00e9lni a te t\u00f6rt\u00e9neted',
    },
    connect: {
      eyebrow: 'Ismerj\u00fck meg egym\u00e1st', title: 'Kapcsolat',
      lead: 'K\u00edv\u00e1ncsi vagy egy k\u00f6zelg\u0151 esem\u00e9nyre, bejelentkezn\u00e9l vagy gondolkodsz, hogy egy\u00e1ltal\u00e1n neked val\u00f3-e? \u00cdrj! Nincs jelent\u00e9ktelen k\u00e9rd\u00e9s, minden \u00fczenetet \u00e9n magam olvasok el \u00e9s v\u00e1laszolok meg. \u00cdgy tudok felaj\u00e1nlani ig\u00e9ny eset\u00e9n egy 15 perces online besz\u00e9lget\u00e9st is, ahol jobban megismerhetsz engem \u00e9s a m\u00f3dszerem.',
      name: 'A neved', email: 'E-mail c\u00edm', message: 'Miben seg\u00edthetek', send: 'K\u00fcld\u00e9s',
      sending: 'K\u00fcld\u00e9s\u2026', sent: 'Meg\u00e9rkezett. Hamarosan v\u00e1laszolok.', error: 'Valami elcsendes\u00fclt. K\u00e9rlek pr\u00f3b\u00e1ld \u00fajra.',
      newsletterTitle: 'A bels\u0151 k\u00f6r',
      newsletterLead: 'H\u00edrlev\u00e9l helyett kollekt\u00edva, zaj helyett jelent\u00e9s \u2014 ahol id\u0151r\u0151l id\u0151re exkluz\u00edv megh\u00edv\u00f3kat \u00e9s intuit\u00edv gondolatokat k\u00fcld\u00f6k, szem\u00e9lyre szabva, szem\u00e9lyesen.',
      subscribe: 'Feliratkoz\u00e1s', subscribing: 'Feliratkoz\u00e1s\u2026', subscribed: 'Bent vagy. Üdv.', mailDirect: 'Vagy l\u00e9pj kapcsolatba k\u00f6zvetlen\u00fcl',
    },
    footer: {
      rights: 'Minden jog fenntartva',
      designed: 'Minden jog fenntartva',
      marquee: ['elenged\u00e9s', 'befogad\u00e1s', 'kiteljesed\u00e9s', 'eredetis\u00e9g', 'ritu\u00e1l\u00e9'],
    },
    privacy: {
      title: 'Adatv\u00e9delem', back: 'Vissza', updated: 'Utolj\u00e1ra friss\u00edtve',
      sections: [
        {
          h: 'Adatv\u00e9delem',
          paragraphs: [
            'Az adataid fontosak neked. Nek\u00fcnk is. Ez\u00e9rt legjobb tud\u00e1sunk \u00e9s lelkiismeret\u00fcnk szerint kezelj\u00fck azokat. Ennek jogi alapj\u00e1t az eur\u00f3pai \u00e1ltal\u00e1nos adatv\u00e9delmi rendelet (GDPR) adja. Ezt \u00e9s m\u00e1s Ausztri\u00e1ban \u00e9rv\u00e9nyes adatv\u00e9delmi szab\u00e1lyoz\u00e1st itt n\u00e9zhetsz meg: {gesetze}',
            'Az al\u00e1bbi adatv\u00e9delmi nyilatkozat a {site} oldalra vonatkozik \u2014 ha m\u00e1s oldalakra hivatkozunk, \u00e9s gyakran hivatkozunk, azoknak m\u00e1s adatv\u00e9delmi szab\u00e1lyaik lehetnek. Adatv\u00e9delmi nyilatkozatunkat rendszeresen friss\u00edtj\u00fck is, amikor m\u00e9g jobb m\u00f3dot tal\u00e1lunk az adataid biztons\u00e1gos kezel\u00e9s\u00e9re, vagy amikor a jogalkot\u00f3 erre k\u00f6telez minket.',
          ],
        },
        {
          h: 'Jogok',
          paragraphs: [
            'A GDPR szerint jogod van t\u00e1j\u00e9koztat\u00e1st kapni a r\u00e1d vonatkoz\u00f3 adatokr\u00f3l, valamint jogod van azok helyesb\u00edt\u00e9s\u00e9re, t\u00f6rl\u00e9s\u00e9re, az adatkezel\u00e9s korl\u00e1toz\u00e1s\u00e1ra \u00e9s az adatkezel\u00e9s elleni tiltakoz\u00e1sra. Ezekkel az \u00fcgyekkel k\u00e9rlek fordulj hozz\u00e1nk a {email} c\u00edmen. A lehet\u0151 leggyorsabban v\u00e1laszolunk a k\u00e9rdesedre.',
          ],
        },
        {
          h: 'H\u00edrlev\u00e9l',
          paragraphs: [
            'H\u00edrlevel\u00fcnket csak azoknak k\u00fcldj\u00fck, akik a {site} oldalon vagy esem\u00e9nyeinken szem\u00e9lyesen feliratkoztak r\u00e1. Ennek biztos\u00edt\u00e1s\u00e1ra dupla opt-in elj\u00e1r\u00e1st haszn\u00e1lunk: a feliratkoz\u00e1st k\u00f6vet\u0151en azonnal egy meger\u0151s\u00edt\u0151 emailt k\u00fcld\u00fcnk neked. Amint aktiv\u00e1lod a meger\u0151s\u00edt\u0151 linket, az email c\u00edmedet a tov\u00e1bbi kommunik\u00e1ci\u00f3hoz haszn\u00e1ljuk. \u00cdgy biztos\u00edtjuk, hogy ne k\u00fcldj\u00fcnk k\u00e9retlen leveleket. Mag\u00e1t\u00f3l \u00e9rtet\u0151d\u0151, hogy minden lev\u00e9l tartalmaz egy linket a leiratkoz\u00e1shoz.',
          ],
        },
        {
          h: 'S\u00fctik',
          paragraphs: [
            'Amint megl\u00e1togatod weboldalunkat, automatikusan napl\u00f3f\u00e1jl j\u00f6n l\u00e9tre a szerver\u00fcnk\u00f6n a technikai biztons\u00e1g \u00e9s szolg\u00e1ltat\u00e1saink fejleszt\u00e9se \u00e9rdek\u00e9ben. Ehhez t\u00f6bbek k\u00f6z\u00f6tt s\u00fctiket haszn\u00e1lunk. Egyes s\u00fctik addig maradnak a k\u00e9sz\u00fcl\u00e9keden, am\u00edg ki nem t\u00f6rl\u00f6d \u0151ket. Ezek lehet\u0151v\u00e9 teszik, hogy a k\u00f6vetkez\u0151 l\u00e1togat\u00e1sodkor felismerj\u00fck a b\u00f6ng\u00e9sz\u0151det. Ha ezt nem szeretn\u00e9d, term\u00e9szetesen \u00fagy \u00e1ll\u00edthatod be a b\u00f6ng\u00e9sz\u0151det, hogy \u00e9rtes\u00edtsen t\u00e9ged a s\u00fctik elhelyez\u00e9s\u00e9r\u0151l \u00e9s enged\u00e9lyt k\u00e9rjen t\u0151led.',
          ],
        },
        {
          h: 'Google Analytics',
          paragraphs: [
            'Weboldalunk arculat\u00e1nak fejleszt\u00e9s\u00e9hez Google Analyticset haszn\u00e1lunk. Ez a webelemz\u0151 szolg\u00e1ltat\u00e1s s\u00fctiket haszn\u00e1l a weboldal haszn\u00e1lat\u00e1nak \u00e9rt\u00e9kel\u00e9s\u00e9re. Az inform\u00e1ci\u00f3kat a weboldal haszn\u00e1lat\u00e1r\u00f3l \u00e1ltal\u00e1ban az USA-ban l\u00e9v\u0151 szerverre tov\u00e1bb\u00edtja \u00e9s ott t\u00e1rolja. A {site} aktiv\u00e1lt IP-anonimiz\u00e1l\u00e1ssal haszn\u00e1lja a Google Analyticset, \u00edgy az IP-c\u00edmed az Eur\u00f3pai Uni\u00f3n bel\u00fcl ler\u00f6vid\u00fcl \u00e9s anonimiz\u00e1l\u00f3dik. A Google Analytics keret\u00e9ben a b\u00f6ng\u00e9sz\u0151d \u00e1ltal tov\u00e1bb\u00edtott IP-c\u00edmet a Google nem kombin\u00e1lja m\u00e1s adatokkal.',
          ],
        },
        {
          h: 'Kapcsolat',
          paragraphs: [
            'Ha k\u00e9rd\u00e9sed van az adataid kezel\u00e9s\u00e9vel kapcsolatban, \u00edrj nek\u00fcnk a {email} c\u00edmre. Tov\u00e1bbi t\u00e1j\u00e9koztat\u00e1st az osztr\u00e1k Adatv\u00e9delmi Hat\u00f3s\u00e1gt\u00f3l k\u00e9rhetsz ({dsb}). Ehhez a hat\u00f3s\u00e1ghoz fordulhatsz akkor is, ha v\u00e9lem\u00e9nyed szerint az adataid kezel\u00e9s\u00e9vel megs\u00e9rtett\u00fck az adatv\u00e9delmi rendelkez\u00e9seket.',
          ],
        },
      ],
    },
    common: { lang: 'HU' },
  },
};
